<div class="row mb-5 d-flex justify-content-start">
	<button
		*ngIf="addable"
		class="col-lg-2 col-5 my-2 mx-2 btn theme-green-button"
		(click)="addEvent.emit($event)"
	>
		<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i> Ajouter
	</button>
	<button
		*ngIf="isImportable"
		class="col-lg-2 col-5 my-2 mx-2 btn theme-bs-light-button"
		(click)="importingEvent.emit($event)"
	>
		<i class="fs-5 bi bi-upload" aria-hidden="true"></i> Importer
	</button>
	<button
		*ngIf="isExportable"
		class="col-lg-2 col-5 my-2 mx-2 btn theme-bs-light-button"
		(click)="exportingEvent.emit($event)"
	>
		<i class="fs-5 bi bi-download" aria-hidden="true"></i> Exporter
	</button>
</div>

<div>
	<ul class="nav border-bottom">
		<li
			class="nav-item col-xs-6 overflow-hidden text-nowrap"
			*ngFor="let tab of tabs"
		>
			<a
				class="nav-link theme-main-color"
				(click)="scrollTop()"
				[routerLink]="[tab.path]"
				[ngClass]="{
					'active fw-bold border-0 border-bottom border-3 border-custom-theme':
						isRouterActive(tab.parentPath)
				}"
				>{{ tab.name }}</a
			>
		</li>
	</ul>
</div>
